import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { SessionService } from '../services/session.service';

@Component({
  standalone:true,
  imports:[CommonModule, FormsModule, MatAutocompleteModule, MatInputModule],
  template:`
   <!-- CONTACT INFORMATION TABS -->
   <div *ngIf="selectedContact">
      <div class="contact-Heading">{{selectedContactDisplay}}</div>
      <div class="actions">
        <div class="action"
              *ngFor="let a of topOptions"
              [class.active]="selectedTopOption===a"
            (click)="selectTopOption(a, selectedContact)">
          <div class="circle">
            <img [src]="a.icon" class="action-img">
          </div>
          <div>{{a.name}}</div>
        </div>
      </div>
    </div>
    <div class="contacts-card" *ngIf="!selectedContact">
      <!-- CONTACT LIST -->
      <div *ngIf="!selectedContact && !showAddNewContact">
        <!-- ADD CONTACT BUTTON -->
        <div class="edit-only-top-bar" >
          <div class="top-actions">
            <button class="icon-btn " (click)="showAddNewContact = true">
              <span class="icon-text">+</span>
            </button>
          </div>
        </div>
        <div class="section-title">
          Manage Contacts
        </div>
        <!-- ACTIVE/INACTIVE -->
        <div class="line-segment">
          <div [class.selected]="showActiveContacts"
              (click)="changeContactsList(true)">
            Active contacts
          </div>
          <div [class.selected]="!showActiveContacts"
              (click)="changeContactsList(false)">
            Inactive contacts
          </div>
        </div>

        <!-- CONTACT SEARCH INPUT -->
        <div class="search-box">
          <input class="search-input"
                placeholder="Search contact"
                [(ngModel)]="searchInput">
          <span class="search-icon">⌕</span>
        </div>
        <!-- CONTACTS LIST-->
        <div class="contacts-scroll">
          <div class="table-list">
            <div class="row"
                *ngFor="let c of filteredContacts()"
                (click)="openContact(c)">
              <div class="contact-details">
                <strong class="tx-title">
                  {{c.name}}
                </strong>
                <small class="tx-number">
                  {{c.phone}}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ADD CONTACT -->
      <div *ngIf="showAddNewContact">
        <div class="back-btn"
            (click)="closeAddNewContact()">
          ←
        </div>
        <div class="section-title">
          New Contact
        </div>
        <!-- NAME -->
        <div>
         <label class="field-label">Name</label>
          <input class="input"
                placeholder="Enter name"
                [(ngModel)]="newContactName"
                (ngModelChange)="contactNameValidationMessage=''">
          <div class="validation-message" *ngIf="contactNameValidationMessage">
            {{contactNameValidationMessage}}
          </div>
          <!-- WHATSAPP NUMBER -->
          <label class="field-label">WhatsApp Number</label>
          <div class="phone-input">
            <div class="phone-flag">
              <img src="assets/images/sa-flag.png"
                  class="flag-img">
            </div>
              <input
              class="phone-number-input"
              type="text"
              inputmode="numeric"
              maxlength="10"
              placeholder="Enter WhatsApp number"
              [(ngModel)]="newContactPhone"
              (keydown)="allowOnlyNumbers($event)"
              (ngModelChange)="onNewContactPhoneInput($event)">
          </div>
           <div class="validation-message" *ngIf="contactWhatsappNumberValidationMessage">
            {{contactWhatsappNumberValidationMessage}}
          </div>
        </div>
        <!-- BUTTONS -->
        <div class="btns mt-20px">
          <button class="set-authorization-btn"
              (click)="addNewContact()"
              [disabled]="!newContactName || !whatsappNumberValid">
              Add
            </button>
        </div>
      </div>    
    </div>

    <div class="profile-card" *ngIf="selectedContact">
    <!-- CONTACT DETAILS -->
    <div *ngIf="selectedTopOption.name === 'Info' && selectedContact">
        <!-- INFO ACTIONS -->
        <div class="top-bar" *ngIf="showContactInfoOptions">
          <div class="back-btn"
              (click)="selectedContact = null">
            ←
          </div>
          <div class="top-actions">
            <button class="icon-btn "
                      (click)="updateContactStatus(selectedContact)">
                <span class="material-icons status-icon" 
                  [class.active-icon]="selectedContact.isActive" 
                  [class.inactive-icon]="!selectedContact.isActive"> 
                  {{ selectedContact.isActive ? 'toggle_on' : 'toggle_off' }}
                </span>
              </button>
            <button class="edit-icon-btn"
                    (click)="editContact(selectedContact)">
              ✎
            </button>
          </div>
        </div>
        <!-- CONTACT INFO -->
        <div class="section-title">{{contactInfoHeading}}</div>
        <div>
          <!-- NAME -->       
          <div class="field">
            <label class="field-label">Name</label>
            <input class="input"
                  placeholder="Enter name"
                  [(ngModel)]="selectedContact.name"
                  [readonly]="isContactReadonly"
                  (ngModelChange)="contactNameValidationMessage=''">
            <div class="validation-message" *ngIf="contactNameValidationMessage">
              {{contactNameValidationMessage}}
            </div>
          </div>
            <!-- WHATSAPP NUMBER -->
          <div class="field">
            <label class="field-label">WhatsApp Number</label>
            <div class="phone-input">
              <div class="phone-flag">
                <img src="assets/images/sa-flag.png"
                    class="flag-img">
              </div>
              <input class="phone-number-input"
                    placeholder="Enter WhatsApp number"
                    [(ngModel)]="selectedContact.phone"
                    [readonly]="true">
            </div>
          </div>
          <!-- BUTTONS -->
          <div class="btns mt-20px" *ngIf="showEditContactButtons">
            <button class="cancel"
                    (click)="CancelEditContact(tempContactName)">
              Cancel
            </button>
            <button class="primary"
                    (click)="updateContact()">
              Save
            </button>
          </div>
        </div>
      </div>

      <!-- PAYSHAP ACCOUNTS -->
      <div *ngIf="selectedTopOption.name === 'Bank Accounts' && selectedContact && !selectedPayshapAccount && !showAddNewPayshapAccount && !showAddNewContact">
        <!-- ADD PAYSHAP ACCOUNT BUTTON -->
        <div class="top-bar">
          <div class="back-btn"
              (click)="selectedContact = null">
            ←
          </div>
          <div class="top-actions">
              <button class="icon-btn "
                    (click)="onAddNewPayshapAccount();">
              <span class="icon-text">+</span>
            </button>
          </div>
        </div>
        <!-- HEADING -->
        <div class="section-title">
          Bank Accounts
        </div>
        <!-- ACTIVE/INACTIVE -->
        <div class="line-segment">
          <div [class.selected]="showActivePayshapAccounts"
              (click)="changePayshapAcountsList(true)">
            Active accounts
          </div>
          <div [class.selected]="!showActivePayshapAccounts"
              (click)="changePayshapAcountsList(false)">
            Inactive accounts
          </div>
        </div>
        <!-- ACCOUNT SEARCH INPUT -->
        <div class="search-box">
          <input class="search-input"
                placeholder="Search account"
                [(ngModel)]="searchInput">
          <span class="search-icon">⌕</span>
        </div>
        <!-- PAYSHAP ACCOUNTS LIST-->
        <div class="selected-contact-scroll">
          <div class="table-list">
            <div class="row" *ngFor="let c of filteredPayshapAccounts()" 
              (click)="openPayshapAccount(c)">
              <div class="contact-details">
                <strong class="tx-title">{{ c.bankName }}</strong>
                <small class="tx-number">{{ c.accountNumber }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- PAYSHAP ACCOUNT DETAILS -->
      <div *ngIf="selectedTopOption.name === 'Bank Accounts' && selectedPayshapAccount">
        <div class="top-bar" *ngIf="showPayshapAccountInfoOptions">
          <div class="back-btn"
              (click)="selectedPayshapAccount = null">
            ←
          </div>
          <div class="top-actions">
            <button class="icon-btn" (click)="updatePayshapAccountStatus(selectedPayshapAccount)">
              <span class="material-icons status-icon" 
                [class.active-icon]="selectedPayshapAccount.isActive" 
                [class.inactive-icon]="!selectedPayshapAccount.isActive"> 
                {{ selectedPayshapAccount.isActive ? 'toggle_on' : 'toggle_off' }}
              </span>
            </button>
          </div>
        </div>
        <div class="section-title">
          Bank Account Info
        </div>
        <div>
          <div class="field">
            <!-- BANK -->
            <div>
              <label class="field-label">Bank</label>
              <input class="input" placeholder="{{selectedPayshapAccount.bankName}}" readonly>
            </div>
            <!-- BRANCH CODE -->
            <div>
              <label class="field-label">Branch Code</label>
              <input class="input" placeholder="{{selectedPayshapAccount.bankBranchCode}}" readonly>
            </div>
            <!-- ACCOUNT NUMBER -->
            <div class="field">
              <label class="field-label">Account Number</label>
              <input class="input" placeholder="{{selectedPayshapAccount.accountNumber}}" readonly>
            </div>
          </div>
        </div>
      </div>

      <!-- ADD PAYSHAP ACCOUNT -->
      <div *ngIf="selectedTopOption.name === 'Bank Accounts' && !selectedPayshapAccount && showAddNewPayshapAccount">
        <div *ngIf="showSelectBank">
         <div class="back-btn" (click)="closeAddNewPayshapAccount()">
          ←
        </div>
        <div class="section-title">
          New Bank Account
        </div>
          <div class="search-box">
            <input class="search-input"
                  placeholder="Search bank"
                  [(ngModel)]="bankSearchInput"
                   (ngModelChange)="filterBanks()">
            <span class="search-icon">⌕</span>
          </div>
          <div class="category-option" *ngFor="let p of filteredBanks"
            [class.selected]="selectedBank === p"
            (click)="selectBank(p)">
            <div class="payment-option-left">
              <span>{{ p.name }}</span>
            </div>
            <div class="tx-icon">
                <img [src]="p.logo"
                    class="tx-img">
            </div>
          </div>
        </div>
      
        <div *ngIf="showNewBankDetails">
          <div class="back-btn" (click)="returnToBanks()">
            ←
          </div>
          <div class="section-title">
            New Bank Account
          </div>
          <div class="field">
            <label class="field-label">Bank</label>
            <div class="input-with-icon">
              <input
                class="input"
                [value]="selectedBank?.name"
                readonly>
              <img
                *ngIf="selectedBank"
                [src]="selectedBank.logo"
                class="bank-logo">
            </div>
          </div>
          <div class="field">
            <label class="field-label">Branch Code</label>
            <input class="input" placeholder="{{bankBranchCode}}" readonly>
          </div>
          <!-- ACCOUNT NUMBER -->
          <div class="field">
            <label class="field-label">Account Number</label>
            <input
              class="input"
              type="text"
              inputmode="numeric"
              maxlength="20"
              placeholder="Enter account number"
              [(ngModel)]="newAccountNumber"
              (keydown)="allowOnlyNumbers($event)"
              (ngModelChange)="onAccountNumberInput($event)">
            <div class="validation-message" *ngIf="newAccountNumberValidationMessage">
              {{newAccountNumberValidationMessage}}
            </div>   
          </div>

          <!-- BUTTONS -->
          <div class="btns">
            <button class="set-authorization-btn"
              (click)="addNewPayshapAccount()"
              [disabled]="!newAccountNumber || !accountNumberValid">
              Add
          </button>
          </div>
        </div>
      </div>

      <!-- UTILITIES -->
      <div *ngIf="selectedTopOption.name === 'Utilities'  && selectedContact && !selectedElectricityMeter && !showAddNewElectricityMeterTab && !showAddNewContact">
        <!-- ADD METER BUTTON -->
        <div class="top-bar">
          <div class="back-btn"
              (click)="selectedContact = null">
            ←
          </div>
          <div class="top-actions">
              <button class="icon-btn "
                    (click)="onAddNewElectricityMeter();">
              <span class="icon-text">+</span>
            </button>
          </div>
        </div>

        <!-- HEADING -->
        <div class="section-title">
          Electricity meters
        </div>
        <!-- ACTIVE/INACTIVE -->
        <div class="line-segment">
          <div [class.selected]="showActiveElectricityMeters"
              (click)="changeElectricityMetersList(true)">
            Active meters
          </div>
          <div [class.selected]="!showActiveElectricityMeters"
              (click)="changeElectricityMetersList(false)">
            Inactive meters
          </div>
        </div>
        <!-- METER SEARCH INPUT -->
        <div class="search-box">
          <input class="search-input"
                placeholder="Search meter"
                [(ngModel)]="searchInput">
          <span class="search-icon">⌕</span>
        </div>
        <!-- METERS LIST-->
        <div class="selected-contact-scroll">
          <div class="table-list">
            <div class="row" *ngFor="let c of filteredElectricityMeters()"
              (click)="openElectricityMeter(c)">
              <div class="contact-details">
                <strong class="tx-title">{{c.name}}</strong>
                <small class="tx-number">{{c.meterNumber}}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ADD METER -->
      <div  *ngIf="selectedTopOption.name === 'Utilities' && !selectedElectricityMeter && showAddNewElectricityMeterTab">
       <div class="back-btn"
              (click)="closeAddMeter()">
            ←
          </div>
        <div class="section-title">
          New electricity meter
        </div>
        <!-- NAME -->
        <div>
          <div class="field">
            <label class="field-label">Meter Name</label>
            <input class="input"
              placeholder="Enter name"
              [(ngModel)]="newMeterName"
              (ngModelChange)="meterNameValidationMessage=''">
            <div class="validation-message" *ngIf="meterNameValidationMessage">
              {{meterNameValidationMessage}}
            </div>
          </div>
          <!-- METER NUMBER -->
          <div class="field">
            <label class="field-label">Meter Number</label>
           <input
              class="input"
              type="text"
              inputmode="numeric"
              maxlength="20"
              placeholder="Enter meter number"
              [(ngModel)]="newMeterNumber"
              (keydown)="allowOnlyNumbers($event)"
              (ngModelChange)="onNewMeterNumberInput($event)">
            <div class="validation-message" *ngIf="meterNumberValidationMessage">
              {{meterNumberValidationMessage}}
            </div>
          </div>
        </div>
        <!-- BUTTONS -->
        <div class="btns">
           <button class="set-authorization-btn"
              (click)="addNewElectricityMeter()"
              [disabled]="!newMeterName || !meterNumberValid">
              Add
            </button>
        </div>
      </div>

      <!-- METER DETAILS -->
      <div *ngIf="selectedTopOption.name === 'Utilities' && selectedElectricityMeter">
        <!-- INFO ACTIONS -->
        <div class="top-bar" *ngIf="ShowElectricityMeterInfoOptions">
          <div class="back-btn"
              (click)="selectedElectricityMeter = null">
            ←
          </div>
          <div class="top-actions">
            <button class="icon-btn "
                      (click)="updateElectricityMeterStatus(selectedElectricityMeter)">
                <span class="material-icons status-icon" 
                  [class.active-icon]="selectedElectricityMeter.isActive" 
                  [class.inactive-icon]="!selectedElectricityMeter.isActive"> 
                  {{ selectedElectricityMeter.isActive ? 'toggle_on' : 'toggle_off' }}
                </span>
              </button>
            <button class="edit-icon-btn"
                    (click)="editElectricityMeter(selectedElectricityMeter)">
              ✎
            </button>
          </div>
        </div>
        <!-- ELECTRICITY METER INFO -->
        <div class="section-title">
            {{utilityInfoHeading}}
        </div>
        <div>
          <!-- NAME -->
          <div class="field">
            <label class="field-label">Name</label>
            <input class="input"
              placeholder="Enter name"
              [(ngModel)]="selectedElectricityMeter.name"
              [readonly]="isElectricityMeterReadonly"
              (ngModelChange)="meterNameValidationMessage=''">
            <div class="validation-message" *ngIf="meterNameValidationMessage">
              {{meterNameValidationMessage}}
            </div>
          </div>
          <!-- METER NUMBER -->
          <div class="field">
            <label class="field-label">Meter Number</label>
            <input class="input"
                    placeholder="Enter meter number"
                    [(ngModel)]="selectedElectricityMeter.meterNumber"
                    [readonly]="true">
          </div>
          <!-- BUTTONS -->
          <div class="btns" *ngIf="ShowEditElectricityMeterButtons">
            <button class="cancel"
                    (click)="CancelEditElectricityMeter()">
              Cancel
            </button>
            <button class="primary"
                    (click)="updateElectricityMeter()">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- SUCCESS ALERT-->
    <div class="overlay" *ngIf="showSuccessAlert">
      <div class="alert-modal">
        <div class="success-icon">
          ✓
        </div>
        <div class="alert-text">
          {{successAlertMessage}}
        </div>
      </div>
    </div>

    <!-- DELETE MODAL -->
    <div class="overlay" *ngIf="showDeactivateAlert">
      <div class="alert-modal">
        <div class="alert-text">
          {{deactivateAlertMessage}}
        </div>
        <div class="logout-actions">
          <button class="cancel-btn"
                  (click)="closeDeactivateAlert()">
            {{deactivateAlertCloseButtonText}}
          </button>
          <button class="yes-btn"
                  (click)="sendDeactivateRequest()">
            {{deactivateAlertConfirmButtonText}}
          </button>
        </div>
      </div>
    </div>
  `
})
export class ContactsPage{
  sessionToken = '';
   constructor(private router: Router, 
                  private sessionService: SessionService) {}
  
      ngOnInit() {
        this.sessionToken = this.sessionService.getSession();
        if (!this.sessionToken) {
          // this.errorMessage = 'Request failed, please reload page and try again.';
          // this.showErrorPopup = true;
          // this.showPageContent = false
          return;
        }
      }
  // =====================================================
  // COMMON
  // =====================================================
  searchInput = '';
  // =====================================================
  // TOP OPTIONS
  // =====================================================
  topOptions=[
  {
    name:'Utilities',
    icon:'assets/images/Topup.png'
  },
  {
    name:'Bank Accounts',
    icon:'assets/images/Withdraw.png'
  },
  {
    name:'Info',
    icon:'assets/images/History.png'
  }
  ];
  selectedTopOption=this.topOptions[2];

  selectTopOption(action: any, contact: any) {
    this.selectedTopOption = action;
    this.searchInput = '';

    if (action.name === 'Utilities') {
      this.closeAddMeter();
      this.selectedElectricityMeter = null;
      this.changeElectricityMetersList(true);
    }
    else if (action.name === 'Bank Accounts') {
      this.closeAddNewPayshapAccount();
      this.selectedPayshapAccount = null;
      this.changePayshapAcountsList(true);
    }
    else if (action.name === 'Info') {
      this.CancelEditContact(contact.name);
      this.changeContactsList(true);
    }
  }
  // =====================================================
  // CONTACT INFO
  // =====================================================
  contacts = [
    {name:'Thandeka',phone:'0832209524',isActive: true},
    {name:'Ernest',phone:'0658318700',isActive: true},
    {name:'Thandeka',phone:'0832209524',isActive: true},
     {name:'Thandeka',phone:'0832209524',isActive: true},
    {name:'Ernest',phone:'0658318700',isActive: true},
    {name:'Thandeka',phone:'0832209524',isActive: false},
     {name:'Thandeka',phone:'0832209524',isActive: true},
    {name:'Ernest',phone:'0658318700',isActive: false},
    {name:'Thandeka',phone:'0832209524',isActive: true},
     {name:'Thandeka',phone:'0832209524',isActive: true},
    {name:'Ernest',phone:'0658318700',isActive: true},
    {name:'Thandeka',phone:'0832209524',isActive: true},
     {name:'Thandeka',phone:'0832209524',isActive: true},
    {name:'Ernest',phone:'0658318700',isActive: true},
    {name:'Thandeka',phone:'0832209524',isActive: true}
  ];
  contactInfoHeading = 'Contact Info';
  selectedContact:any = null;
  tempContactName = '';
  userNumber = '27832209524';
  newContactName = '';
  newContactPhone = '';
  contactNameValidationMessage = '';
  contactWhatsappNumberValidationMessage = '';

  showActiveContacts = true;
  showAddNewContact = false;
  showEditContactButtons = false;
  showContactInfoOptions = true;
  isContactReadonly = true;
  isUserEmailAddressReadonly = true;
  selectedContactDisplay = '';

  openContact(contact:any){
    this.selectedContact = contact;
    this.selectedTopOption=this.topOptions[2];
    this.selectedContactDisplay = `${contact.name} (${contact.phone})`;
  }
  changeContactsList(mode:boolean){
    this.showActiveContacts = mode;
    this.searchInput = '';
  }
  filteredContacts() {
    let contacts = this.contacts;
    contacts = contacts.filter(contact =>
      this.showActiveContacts === true
        ? contact.isActive
        : !contact.isActive
    );
    const search = this.searchInput.toLowerCase();
    return contacts.filter(x =>
      x.name.toLowerCase().includes(search) ||
      x.phone.toLowerCase().includes(search)
    );
  }
  validatePhoneNumber(){
    let mobileRegexPattern = /^(0|\+27|27)[5-8][0-9][0-9]{7}$/;
    let phoneNumber = this.newContactPhone.trim().replace(/\s+/g, '');
    if(!mobileRegexPattern.test(phoneNumber)){
      return {
        isValid:false,
        message:'Invalid WhatsApp number'
      };
    }
    phoneNumber = phoneNumber.replace(/\D/g,'');// REMOVE NON NUMBERS
    if(phoneNumber.startsWith('0')){// CONVERT 076... -> 276...
      phoneNumber = phoneNumber.substring(1);
      phoneNumber = '27' + phoneNumber;
    }
    if(phoneNumber == this.userNumber){
      return {
        isValid:false,
        message:'You cannot add your number as a contact'
      };
    }
    // DISPLAY FORMAT
    let displayNumber = '0' + phoneNumber.substring(2);
    return {
      isValid:true,
      message:'',
      formattedNumber:phoneNumber,
      displayNumber:displayNumber
    };
  }
  onNewContactPhoneInput(){
    const validation =this.validatePhoneNumber();
      if(this.newContactPhone){
        if(!validation.isValid){
            this.contactWhatsappNumberValidationMessage = validation.message;
            this.whatsappNumberValid = false;
          }
          else{
            this.contactWhatsappNumberValidationMessage = '';
            this.whatsappNumberValid = true;
          }
      }
      else
        this.whatsappNumberValid = false;
  }
  addNewContact(){
    let hasError = false;
    this.contactNameValidationMessage = '';
    this.contactWhatsappNumberValidationMessage = '';

    // NAME
    if(!this.newContactName.trim()){
      this.contactNameValidationMessage = 'Contact name is required';
      hasError = true;
    }
    // WHATSAPP NUMBER
    if(!this.newContactPhone.trim()){
      this.contactWhatsappNumberValidationMessage = 'WhatsApp number is required';
      hasError = true;
    }
    else{
      const validation =this.validatePhoneNumber();
      if(!validation.isValid){
        this.contactWhatsappNumberValidationMessage = validation.message;
        hasError = true;
      }
    }      
    if(hasError){
      return;
    }

    //Send request

    //If success
    this.contacts.unshift({
      name:this.newContactName,
      phone:this.newContactPhone,
      isActive: true
    });
    this.successAlertMessage = 'Contact added successfully';
    this.showActiveContacts = true;
    this.showSuccessAlert = true;
    this.isContactReadonly = true;
    this.closeAddNewContact();
    setTimeout(() => { this.showSuccessAlert = false; }, 2000);
  }
  closeAddNewContact(){
    this.showAddNewContact = false;
    this.newContactName = '';
    this.newContactPhone = '';
    this.contactNameValidationMessage = '';
    this.contactWhatsappNumberValidationMessage = '';
  }
  editContact(c:any){
    this.showContactInfoOptions = false;
    this.contactInfoHeading = 'Edit contact info';
    this.isContactReadonly = false;
    this.tempContactName = c.name;
    this.showEditContactButtons = true;
  }
  CancelEditContact(c: string){
    this.showContactInfoOptions = true;
    this.contactInfoHeading = 'Contact info';
    this.isContactReadonly = true;
    this.selectedContact.name = c;
    this.contactNameValidationMessage = '';
    this.showEditContactButtons = false;
  }
  updateContact(){
    let hasError = false;
    let updatedContactName = this.selectedContact.name.trim();
    this.contactNameValidationMessage = '';

    // NAME
    if(!updatedContactName){
      this.contactNameValidationMessage = 'Contact name is required';
      hasError = true;
    }
    else if(updatedContactName == this.tempContactName){
      this.contactNameValidationMessage = 'Update contact name to save';
      hasError = true;
    }    
       
    if(hasError){
      return;
    }

    //Send request

    this.showEditContactButtons = false;
    this.isContactReadonly = true;
    this.showContactInfoOptions = true;

    //If successful
    this.successAlertMessage = 'Contact updated successfully';
    this.showSuccessAlert= true;
    setTimeout(() => { this.showSuccessAlert = false; }, 2000);
  }
  updateContactStatus(c:any){
    this.selectedContact = c;
    if(c.isActive){
     this.deactivateAlertMessage = `Are you sure you want to deactivate ${c.name} (${c.phone})`;
      this.deactivate = 'Contact'
      this.showDeactivateAlert = true;
    }
    else{
      this.selectedContact.isActive = true;
      this.successAlertMessage = 'Contact activated successfully';
      this.showSuccessAlert = true;
      setTimeout(() => { this.showSuccessAlert = false; }, 2000);
    }
  }
  // =====================================================
  // PAYSHAP
  // =====================================================
  banks = [
    {
      id:'1',
      name:'FNB',
      branchCode:'12345',
      logo:'assets/images/FNB.png'
    },
    {
      id:'2',
      name:'Capitec',
      branchCode:'12345',
      logo:'assets/images/Capitec.png'
    },
  ];
  payshapAccounts = [
    {
      bankName:'Capitec',
      bankBranchCode:'12345',
      accountNumber:'548888788',
      logo:'assets/images/Capitec.png',
      isActive: true
    },
    {
      bankName:'FNB',
      bankBranchCode:'12345',
      accountNumber:'745659599',
      logo:'assets/images/FNB.png',
      isActive: true
    }
    ,
    {
      bankName:'FNB',
      bankBranchCode:'12345',
      accountNumber:'745659599',
      logo:'assets/images/FNB.png',
      isActive: false
    }
  ];
  filteredBanks = [...this.banks];
  selectedBank:any = null;
  selectedPayshapAccount:any = null;
  bankValidationMessage = '';
  bankSearchInput = '';
  newAccountNumberValidationMessage = '';
  newAccountNumber = '';

  showAddNewPayshapAccount = false;
  showActivePayshapAccounts = true;
  showPayshapAccountInfoOptions = false;

   showNewBankDetails = false;
  showSelectBank = true;
  bankBranchCode = '';
  accountNumberValid = false;
  whatsappNumberValid = false;
  
  onAddNewPayshapAccount() {
    this.showAddNewPayshapAccount = true;
    this.bankBranchCode = '';
    this.newAccountNumber = '';
    this.selectedBank = null;
    this.showNewBankDetails  = false;
    this.showSelectBank = true;
  }
  closeAddNewPayshapAccount() {
    this.showAddNewPayshapAccount = false;
    this.selectedBank = null;
    this.bankSearchInput = '';
    this.newAccountNumber = '';
    this.filteredBanks = [...this.banks];
    this.bankValidationMessage = '';
    this.newAccountNumberValidationMessage = '';
    this.showPayshapAccountInfoOptions = false;
    this.bankBranchCode = '';
  }
  filterBanks(){
    this.selectedBank = null;
    const search =
      (this.bankSearchInput || '')
        .toString().toLowerCase();

    this.filteredBanks =
      this.banks.filter(x =>
        x.name.toLowerCase().includes(search)
      );
  }
  selectBank(bank:any){
    this.selectedBank = bank;
    this.showNewBankDetails = true;
    this.showSelectBank = false;
    this.bankBranchCode = bank.branchCode;
  }
  addNewPayshapAccount(){
    let hasError = false;
    this.bankValidationMessage = '';
    this.newAccountNumberValidationMessage = '';

    // ACCOUNT NUMBER
    if(!this.newAccountNumber.trim()){
      this.newAccountNumberValidationMessage = 'Account number is required';
      hasError = true;
    }
    else{
      const validation =this.validateAccountNumber();
      if(!validation.isValid){
        this.newAccountNumberValidationMessage = validation.message;
        hasError = true;
      }
    }      

    if(hasError){
      return;
    }

    this.payshapAccounts.unshift({
      bankName: this.selectedBank.name,
      bankBranchCode: this.selectedBank.branchCode,
      accountNumber: this.newAccountNumber,
      logo: this.selectedBank.logo,
      isActive: true
    });

    this.successAlertMessage = 'Bank account added successfully';
    this.showSuccessAlert = true;
    this.showActivePayshapAccounts = true;

    setTimeout(() => {
      this.showSuccessAlert = false;
    }, 2000);

    this.closeAddNewPayshapAccount();
  }
  onAccountNumberInput(value: string) {
  this.newAccountNumber = value.replace(/\D/g, '').slice(0, 20);
   const validation =this.validateAccountNumber();
    if(this.newAccountNumber){
      if(!validation.isValid){
          this.newAccountNumberValidationMessage = validation.message;
          this.accountNumberValid = false;
        }
        else{
          this.newAccountNumberValidationMessage = '';
          this.accountNumberValid = true;
        }
    }
    else
       this.accountNumberValid = false;
  }
 validateAccountNumber(){
    let accountNumber = this.newAccountNumber.trim().replace(/\s+/g, '');
    // ONLY NUMBERS
    if(!/^\d+$/.test(accountNumber)){

      return {
        isValid:false,
        message:'Account number must contain only numbers'
      };
    }
    // LENGTH CHECK
    if(accountNumber.length < 6 ||
      accountNumber.length > 20){
      return {
        isValid:false,
        message:'Account number must be between 6 and 20 digits'
      };
    }
    // VALID
    return {
      isValid:true,
      message:''
    };
  }
  changePayshapAcountsList(mode:boolean){
    this.showActivePayshapAccounts = mode;
    this.searchInput = '';
  }
  filteredPayshapAccounts() {
    let accounts = this.payshapAccounts;
    accounts = accounts.filter(account =>
      this.showActivePayshapAccounts === true
        ? account.isActive
        : !account.isActive
    );
    const search = this.searchInput.toLowerCase();
    return accounts.filter(x =>
      x.bankName.toLowerCase().includes(search) ||
      x.accountNumber.toLowerCase().includes(search)
    );
  }
  openPayshapAccount(account:any){
    this.selectedPayshapAccount = account;
    this.showPayshapAccountInfoOptions = true;
  }
  updatePayshapAccountStatus(c:any){
    this.selectedPayshapAccount = c;
    if(c.isActive){
      this.deactivateAlertMessage = `Are you sure you want to deactivate ${c.name} (${c.accountNumber})`;
      this.deactivate = 'PayshapAccount'
      this.showDeactivateAlert = true;
    }
    else{
      this.selectedPayshapAccount.isActive = true;
      this.successAlertMessage = 'Bank account activated successfully';
      this.showSuccessAlert = true;
      setTimeout(() => { this.showSuccessAlert = false; }, 2000);
    }
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End'
    ];

    // Allow control keys
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Block everything except digits
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
  // =====================================================
  // UTILITIES
  // =====================================================
  electricityMeterAccounts = [
  {
    name:'Home',
    meterNumber:'548888788',
    isActive: true
  },
  {
    name:'Apartment',
    meterNumber:'548888788',
    isActive: true
  },
  {
    name:'Midview',
    meterNumber:'745659599',
    isActive: false
    }
  ];
  utilityInfoHeading = 'Electricity meter info';
  selectedElectricityMeter:any = null;
  tempMeterName = '';
  meterNameValidationMessage = '';
  meterNumberValidationMessage = '';
  newMeterName = '';
  newMeterNumber = '';
    meterNumberValid = false;

  showActiveElectricityMeters = true;
  showAddNewElectricityMeterTab = false;
  ShowElectricityMeterInfoOptions = true;
  ShowEditElectricityMeterButtons = false;
  isElectricityMeterReadonly = true;


  onAddNewElectricityMeter() {
    this.showAddNewElectricityMeterTab = true;
    this.newMeterName = '';
    this.newMeterNumber = '';
  }
  onNewMeterNumberInput(){
   const validation =this.validateMeterNumber();
    if(this.newMeterNumber){
      if(!validation.isValid){
          this.meterNumberValidationMessage = validation.message;
          this.meterNumberValid = false;
        }
        else{
          this.meterNumberValidationMessage = '';
          this.meterNumberValid = true;
        }
    }
    else
      this.meterNumberValid = false;
  }
  validateMeterNumber(){
    return {
      isValid:true,
      message:'',
    };
  }
  addNewElectricityMeter(){
    let hasError = false;
    this.meterNameValidationMessage = '';
    this.meterNumberValidationMessage = '';

    // NAME
    if(!this.newMeterName.trim()){
      this.meterNameValidationMessage = 'Meter name is required';
      hasError = true;
    }
    // METER NUMBER
    if(!this.newMeterNumber.trim()){
      this.meterNumberValidationMessage = 'Meter number is required';
      hasError = true;
    }
    else{
      const validation =this.validateMeterNumber();
      if(!validation.isValid){
        this.meterNumberValidationMessage = validation.message;
        hasError = true;
      }
    }

    if(hasError){
      return;
    }

    this.electricityMeterAccounts.unshift({
      name: this.newMeterName,
      meterNumber: this.newMeterNumber,
      isActive: true
    });

    //Make request

    //If successful
    this.successAlertMessage = 'Meter added successfully';
    this.showSuccessAlert = true;
    this.isElectricityMeterReadonly = true;
    setTimeout(() => { this.showSuccessAlert = false; }, 2000);
    this.closeAddMeter();
  }
  closeAddMeter(){
    this.showAddNewElectricityMeterTab = false;
    this.newMeterName = '';
    this.newMeterNumber = '';
    this.meterNameValidationMessage = '';
    this.meterNumberValidationMessage = '';
  }
  changeElectricityMetersList(mode:boolean){
    this.showActiveElectricityMeters = mode;
    this.searchInput = '';
  }
  filteredElectricityMeters(){
    let accounts = this.electricityMeterAccounts;
    accounts = accounts.filter(account =>
      this.showActiveElectricityMeters === true
        ? account.isActive
        : !account.isActive
    );
    const search = this.searchInput.toLowerCase();
    return accounts.filter(x =>
      x.name.toLowerCase().includes(search) ||
      x.meterNumber.toLowerCase().includes(search)
    );
  }
  openElectricityMeter(meter:any){
    this.selectedElectricityMeter = meter;
     this.utilityInfoHeading = 'Electricity meter info';
    this.ShowEditElectricityMeterButtons = false;
    this.ShowElectricityMeterInfoOptions = true;
    this.isElectricityMeterReadonly = true;
    this.meterNameValidationMessage = '';
    this.meterNumberValidationMessage = '';
  }
  editElectricityMeter(c:any){
    this.utilityInfoHeading = 'Edit electricity meter info';
    this.ShowEditElectricityMeterButtons = true;
    this.ShowElectricityMeterInfoOptions = false;
    this.isElectricityMeterReadonly = false;
    this.tempMeterName = this.selectedElectricityMeter.name;
    
  }
  updateElectricityMeter(){
    let hasError = false;
    let updatedMeterName = this.selectedElectricityMeter.name.trim();
    this.meterNameValidationMessage = '';
    this.meterNumberValidationMessage = '';

    // NAME
    if(!updatedMeterName){
      this.meterNameValidationMessage = 'Meter name is required';
      hasError = true;
    }
    else if(updatedMeterName == this.tempMeterName){
      this.meterNameValidationMessage = 'Update meter name to save';
      hasError = true;
    }
       
    if(hasError){
      return;
    }

    this.successAlertMessage = 'Meter updated successfully';
    this.showSuccessAlert = true;
    this.ShowEditElectricityMeterButtons = false;
    this.isElectricityMeterReadonly = true;
    this.ShowElectricityMeterInfoOptions = true;
    setTimeout(() => { this.showSuccessAlert = false; }, 2000);
  }
  CancelEditElectricityMeter(){
    this.utilityInfoHeading = 'Electricity meter info';
    this.ShowEditElectricityMeterButtons = false;
    this.ShowElectricityMeterInfoOptions = true;
    this.isElectricityMeterReadonly = true;
    this.meterNameValidationMessage = '';
    this.meterNumberValidationMessage = '';
    this.selectedElectricityMeter.name = this.tempMeterName;
    this.tempMeterName = '';
  }
  updateElectricityMeterStatus(c:any){
    this.selectedElectricityMeter = c;
    if(c.isActive){
      this.deactivateAlertMessage =
        `Are you sure you want to deactivate ${c.name} (${c.meterNumber})`;
      this.deactivate = 'ElectricityMeter'
      this.showDeactivateAlert = true;
    }
    else{
      this.selectedElectricityMeter.isActive = true;
      this.successAlertMessage = 'Meter activated successfully';
      this.showSuccessAlert = true;
      setTimeout(() => { this.showSuccessAlert = false; }, 2000);
    }
  }
  // =====================================================
  // ALERTS
  // =====================================================
  showSuccessAlert=false;
  successAlertMessage = '';
  showDeactivateAlert = false;
  deactivateAlertMessage = '';
  deactivateAlertConfirmButtonText = 'Yes';
  deactivateAlertCloseButtonText = 'No';
 
  closeDeactivateAlert(){
    this.showDeactivateAlert = false;
    this.deactivate = '';
  }  
  // =====================================================
  // INFO, PAYSHAP, AND UTILITIES DEACTIVATE
  // =====================================================
  deactivate = '';
  sendDeactivateRequest(){
    this.showDeactivateAlert = false;

    if(this.deactivate == 'ElectricityMeter'){
      this.successAlertMessage = 'Meter deactivated successfully';
      this.selectedElectricityMeter.isActive = false;
    }
    else if(this.deactivate == 'PayshapAccount'){
      this.successAlertMessage = 'Bank account deactivated successfully';
      this.selectedPayshapAccount.isActive = false;
    }
    else if(this.deactivate == 'Contact'){
      this.successAlertMessage = 'Contact deactivated successfully';
      this.selectedContact.isActive = false;
    }

    this.deactivate = '';
    this.showSuccessAlert = true;
    
    setTimeout(() => {
      this.showSuccessAlert = false;
    }, 2000);
  }

   returnToBanks(){
    this.selectedBank = null;
      this.bankBranchCode = '';
      this.newAccountNumber = '';
      this.showNewBankDetails  = false;
      this.showSelectBank = true;
  }
}